export default __webpack_public_path__ + "static/media/hht2_ep19_timeline_q01_a.84d68eb1.png";